<mat-form-field *ngIf="formControl" appearance="outline" [ngClass]="{'readonly-field': readonly}"
  style="width: 100%; margin-top: 12px;">
  <mat-label>{{field?.label}}</mat-label>
  <input matInput (blur)="readonly = true" [readonly]="readonly" [formControl]="formControl"
    [placeholder]="field?.placeholder || ''" type="text">
  <button matIconSuffix mat-icon-button color="primary" [disabled]="formControl.disabled" (click)="readonly = false">
    <mat-icon>edit_outline</mat-icon>
  </button>

  <mat-error>{{field?.errorMessage}}</mat-error>
  <mat-hint>{{field?.hint}}</mat-hint>
</mat-form-field>